import React from 'react';
import { Space } from 'antd';

const Space2 = (props) => <Space className='btn' {...props} />;

export default Space2;
